import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import keycode from 'keycode';
import moment from 'moment';
import { NotificationContainer, NotificationManager } from 'react-notifications';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableFooter from '@material-ui/core/TableFooter';
import TableHead from '@material-ui/core/TableHead';
import TablePagination from '@material-ui/core/TablePagination';
import TableRow from '@material-ui/core/TableRow';
import TableSortLabel from '@material-ui/core/TableSortLabel';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';
import Checkbox from '@material-ui/core/Checkbox';
import IconButton from '@material-ui/core/IconButton';
import Tooltip from '@material-ui/core/Tooltip';
import DeleteIcon from '@material-ui/icons/Delete';
import FilterListIcon from '@material-ui/icons/FilterList';
import TextField from '@material-ui/core/TextField';
import InputAdornment from '@material-ui/core/InputAdornment';
import Search from '@material-ui/icons/Search';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import Button from '@material-ui/core/Button';
import axios from 'axios'
import Slide from '@material-ui/core/Slide';
import Grid from '@material-ui/core/Grid';
import AppBar from '@material-ui/core/AppBar';
import AddIcon from '@material-ui/icons/Add';
import Paper from '@material-ui/core/Paper';
import SweetAlert from 'react-bootstrap-sweetalert';
import Nprogress from 'nprogress';
import 'nprogress/nprogress.css';
import ReactToExcel from 'react-html-table-to-excel';
import PopupState, { bindMenu, bindTrigger, bindPopover } from 'material-ui-popup-state';
import Menu from "@material-ui/core/Menu";
import MenuItem from '@material-ui/core/MenuItem';
import LinearProgress from '@material-ui/core/LinearProgress';

function Transition(props) {
    return <Slide direction="up" {...props} />;
}

import InputVirtual from 'components/InputVirtual'
import DialogAdd from './DialogAdd';
import DialogEdit from './DialogEdit';
import { Divider } from '@material-ui/core';

import { BASE_URL_JAVAZ_API, BASE_HEADER, FILE_HEADER, BASE_URL_API } from "constants/ActionTypes";
const companyId = localStorage.getItem('companyId')
const token = localStorage.getItem('apiKey')
const config = {
    headers: {
        'Content-Type': 'application/json',
        "Authorization": `Bearer ${token}`
    }
}
//length data for general
const LENGTH_DATA = 25
const URL_SEARCH = `${BASE_URL_JAVAZ_API}/vehicle/search`
const masterTitleCapital = "Aset";
const masterTitle = "vehicle";

function Transition(props) {
    return <Slide direction="up" {...props} />;
}

const options = [
    'Name',
    'License Plate',
    'Callisto',
    'Dione',
];

const columnData = [
    { label: 'Perusahaan' },
    { label: 'Nomor Plat' },
    { label: 'Tipe Aset' },
    { label: 'Vendor' },
    { label: 'Body Name'},
    { label: 'Kantor' },
    { label: 'Maintenance' },
];

const styles = theme => ({
    appBar: {
        position: 'relative',
    },
    flex: {
        flex: 1,
    },
    button: {
        margin: theme.spacing.unit,
    },
    leftIcon: {
        marginRight: theme.spacing.unit,
    },
    rightIcon: {
        marginLeft: theme.spacing.unit,
    },
    paper: {
        ...theme.mixins.gutters(),
        paddingTop: theme.spacing.unit * 2,
        paddingBottom: theme.spacing.unit * 2,
    },
    table: {
        minWidth: '1000px',
    },
});


class MasterVehicle extends React.Component {

    renderSearch = () => {
        const { searchField } = this.props
        const { data, totalRecord } = this.state
        return searchField.map(res => {
            if (res.searchAble === true) {
                if (res.field.type === 'basic') {
                    return (
                        <Grid item xs={4}>
                            <TextField
                                id="standard-uncontrolled"
                                label="asda"
                                defaultValue="foo"
                                margin="normal"
                            />
                        </Grid>
                    )
                } else {
                    if (data.length > 0) {
                        return (
                            <Grid item xs={4}>
                                <InputVirtual
                                    countRecord={totalRecord}
                                    recordData={data}
                                    loadRows={this._loadMoreRows}
                                    inputText={this.handleInputDialog}
                                    getData={this.getCompany}
                                />
                            </Grid>
                        )
                    }
                }
            }
        })

    }

    handleClickOpen = () => {
        this.setState({ open: true });
    };

    createSortHandler = property => event => {
        this.props.onRequestSort(event, property);
    };

    handleMasterVehicle = async (start, end) => {
        const data = {
            paging: { start: start, length: end },
            orders: { columns: ["id"], ascending: false },
            joins: [
                { name: "company", column_results: ["name"] },
                { name: "pool", column_results: ["name"] },
                { name: "vehicle_type", column_results: ["name"] },
                { name: "vendor", column_results: ["name"] },
            ],
            columns: [
                ... this.state.searchTableName.toString() !== "" ? [{ name: this.state.searchDetailField, "logic_operator": "like", value: this.state.search, "operator": "AND", "table_name": this.state.searchTableName }] : 
                [{ name: this.state.searchDetailField, "logic_operator": "like", value: this.state.search, "operator": "AND" }]
            ],
        }
        let objDD = JSON.stringify(data)
        const result = await axios.post(URL_SEARCH, objDD, config).then(res => res).catch(error => error.response)
        // console.log(result)
        if (result.data.code === 200) {
            this.setState({
                dataVehicle: result.data.data, totalRecordVehicle: result.data.totalRecord,
            })
        }
    }

    handleRequestDataExport = async () => {
        const data = {
            paging: { start: 0, length: -1 },
            orders: { columns: ["name"], ascending: true },
            joins: [
                { name: "company", column_results: ["name"] },
                { name: "pool", column_results: ["name"] },
                { name: "vehicle_type", column_results: ["name"] },
                { name: "vendor", column_results: ["name"] },
            ],
            columns: [
                ... this.state.searchTableName.toString() !== "" ? [{ name: this.state.searchDetailField, "logic_operator": "like", value: this.state.search, "operator": "AND", "table_name": this.state.searchTableName }] : 
                [{ name: this.state.searchDetailField, "logic_operator": "like", value: this.state.search, "operator": "AND" }]
            ],

        }

        let objDD = JSON.stringify(data)
        const result = await axios.post(URL_SEARCH, objDD, config).then(res => res).catch(error => error.response)
        // console.log('dataVehicleExport ',result)
        if (result.data.code === 200 && result.data.totalRecord > 0) {
            this.setState({
                dataVehicleExport: result.data.data
            })
        }
        return true;
    }

    async componentDidMount() {
        this.handleMasterVehicle(0, this.state.rowsPerPage)
        this.handleRequestDataExport()
    }

    handleRequestSort = (event, property) => {
        const orderBy = property;
        let order = 'desc';

        if (this.state.orderBy === property && this.state.order === 'desc') {
            order = 'asc';
        }

        const data =
            order === 'desc'
                ? this.state.data.sort((a, b) => (b[orderBy] < a[orderBy] ? -1 : 1))
                : this.state.data.sort((a, b) => (a[orderBy] < b[orderBy] ? -1 : 1));

        this.setState({ data, order, orderBy });
    };
    handleSelectAllClick = (event, checked) => {
        if (checked) {
            this.setState({ selected: this.state.data.map(n => n.id) });
            return;
        }
        this.setState({ selected: [] });
    };

    handleChangePage = (event, page) => {
        this.setState({ page })
        const { rowsPerPage } = this.state
        const start = rowsPerPage * page
        // console.log("change page",{start, rowsPerPage})
        this.handleMasterVehicle(start, rowsPerPage)
    };

    async componentDidUpdate(prevProps, prevState) {
        if (this.state.search !== prevState.search) this.handleMasterVehicle(0, this.state.rowsPerPage)
        if (this.state.rowsPerPage !== prevState.rowsPerPage) this.handleMasterVehicle(0, this.state.rowsPerPage)
    }
    handleChangeRowsPerPage = event => {
        this.setState({ rowsPerPage: event.target.value });
    };
    isSelected = id => this.state.selected.indexOf(id) !== -1;

    constructor(props, context) {
        super(props, context);

        this.state = {
            order: 'asc',
            orderBy: 'calories',
            selected: [],
            dataVehicle: [],
            dataVehicleExport: [],
            totalRecordVehicle: 0,
            indexDataVehicle: 20,
            page: 0,
            rowsPerPage: LENGTH_DATA,
            search: '',
            open: false,
            company: '',
            openAdd: false,
            openEdit: false,
            sweetSuccess: false,
            sweetWarning: false,
            dataEdit: null,
            openQr: false,
            urlQr: '',
            nameQr: '',
            openPhoto: false,
            urlPhoto: '',
            nameImage: '',
            searchDetail: 'Nomor Plat',
            searchDetailField: 'license_plate',
            searchTableName: '',
            loading: false,
        };
    }

    handleSearch = e => {
        this.setState({ search: e.target.value })
    }

    handleCloseDialog = async param => {
        if (param === 'tambah') {
            this.handleMasterVehicle(0, this.state.rowsPerPage)
        }

    };

    handleGetLicenseDetail = async id => {
        const data = {
            columns: [{ name: "vehicle_id", logic_operator: "=", value: `${id}`, operator: "AND" }],
            joins: [{ name: "vehicle_license", column_results: ["license_name"] }]
        }

        let objDD = JSON.stringify(data)
        const url = `${BASE_URL_JAVAZ_API}/vehicle-license-detail/search`
        const result = await axios.post(url, objDD, config).then(res => res).catch(error => error.response)
        return result
    }

    handleClickOpenEdit = async data => {
        Nprogress.start();
        const result = await this.handleGetLicenseDetail(data.id)
        // console.log(result)

        if (result.data.code === 200) {
            const arr = []
            result.data.data.map(res => {
                if (res.status == "open") {
                    const obj = {
                        id: res.id,
                        license_exp_date: moment(res.license_exp_date).format('YYYY-MM-DD'),
                        license_no: res.license_no,
                        vehicle_license: res.vehicle_license,
                        photo: res.photo,
                        license_name: res.join.vehicle_license_license_name,
                    }
                    arr.push(obj)
                }
            })
            const date = new Date();
            const url = `${BASE_URL_API}/images/qr_img/vehicle/${companyId}/${data.id}.png?apikey=${token}`
            const urlPhoto = `${BASE_URL_API}/images/vehicle/${companyId}/${data.id}.png?apikey=${token}&${date}`
            // const urlImage = await this.handleGetImage(urlPhoto)
            const arr2 = { ...data, qrcode: url, photo: urlPhoto, vehicle_license: arr }
            // console.log(arr2)
            this.setState({ openEdit: true, dataEdit: arr2 })
        } else {
            NotificationManager.error(result.data.message, 'Error message')
        }
        Nprogress.done();
    }

    handleEditVehicle = async data => {
        const { dataEdit } = this.state
        let obj = JSON.stringify(data)
        const url = `${BASE_URL_JAVAZ_API}/vehicle/edit/${dataEdit.id}`
        const result = await axios.put(url, obj, config).then(res => res).catch(error => error.response)
        return result
    }

    handleCloseEdit = async (param, obj) => {
        if (param === 'batal') {
            // console.log(param)
            this.setState({ openEdit: false, dataEdit: null });
        } else if (param === 'ubah') {
            this.setState({loading: true})
            const result = await this.handleEditVehicle(obj)
            console.log(`ediitt`, result.data)
            if (result.data.status === true) {
                this.handleMasterVehicle(0, this.state.rowsPerPage)
                this.setState({ openEdit: false, dataEdit: null, loading: false });
                NotificationManager.success('Edit Vehicle Success', 'Success message')
            } else {
                this.setState({loading: false})
                NotificationManager.error(result.data.message, 'error message')
            }
        }

    };

    handleCloseSearch = (param) => {
        if (param === 'batal') {
            // console.log(param)
        } else if (param === 'apply') {
            // console.log(param)
        }
        this.setState({ open: false });
    };

    handleDeleteData = (data) => {
        this.setState({ sweetWarning: true, dataDelete: data })
    }

    handleGetImage = async imageURL => {
        let getImage = await axios.head(imageURL).then(response => response).catch(error => error);

        // console.log('getImage', getImage);

        if (getImage == "Error: Request failed with status code 404") {
            // No image in directory
            // console.log('No image in directory', getImage);
            return 'assets/images/blank-image-photo.png'
        }
        else if (getImage.status == 200) {
            // There is an image in directory!
            // console.log('There is an image in directory!', getImage);
            return imageURL
        }
    }

    handleViewQr = (data) => {
        const url = `${BASE_URL_JAVAZ_API}/images/qr_img/vehicle/${companyId}/${data.id}.png?apikey=${token}`
        // console.log(url)
        this.setState({ openQr: true, urlQr: url, nameQr: data.license_plate })
    }

    doDeleteVehicle = async data => {
        // console.log(data.id)
        const url = `${BASE_URL_JAVAZ_API}/vehicle/delete/${data.id}`
        const result = await axios.delete(url, config).then(res => res).catch(error => error.response)
        return result
    }

    handleDelete = async param => {
        if (param === 'batal') {
            // console.log(param)
            this.setState({
                sweetWarning: false,
            })
        } else if (param === 'delete') {
            // console.log(param)
            const { dataDelete, dataVehicle } = this.state
            this.setState({loading: true})
            const result = await this.doDeleteVehicle(dataDelete)
            // console.log(result)
            if (result.data.status === true) {
                NotificationManager.success('Delete Vehicle Success', 'Success message')
                const idx = dataVehicle.indexOf(dataDelete)
                dataVehicle.splice(idx, 1)
            } else {
                NotificationManager.error(result.data.message, 'Error message')
            }

            this.setState({
                sweetWarning: false,
                loading: false,
                dataVehicle
            })
        }
    }

    handleViewPhoto = async data => {
        const date = new Date();
        const urlPhoto = `${BASE_URL_API}/images/vehicle/${companyId}/${data.id}.png?apikey=${token}&${date}`
        // const urlImage = await this.handleGetImage(urlPhoto)
        this.setState({ openPhoto: true, urlPhoto, nameImage: data.license_plate })
    }

    handleShowDialog = () => {
        this.showChildDialog();
    };

    render() {
        const { dataVehicle, order, orderBy, selected, rowsPerPage, page, dataVehicleExport, totalRecordVehicle, search, loading } = this.state;
        const { classes } = this.props

        return (
            <div className="app-wrapper">
                <NotificationContainer />
                <div className="d-sm-flex justify-content-sm-between align-items-sm-center">
                    <div className="col-md-9">
                        <h2 className="title mb-3 mb-sm-0">
                            <span>{masterTitleCapital}</span>
                        </h2>
                    </div>
                    <div className="col-md-3 d-flex justify-content-between">
                        <nav className="mb-0">
                            {/* <ReactToExcel
                            className="jr-btn"
                            table="tabletoexcel"
                            sheet="report"
                            filename = "Export data driver"
                            buttonText="Export Pdf"/> */}
                        </nav>
                        <nav className="mb-sm-0">
                            <ReactToExcel
                                className="jr-btn"
                                table="tabletoexcel"
                                sheet="report"
                                filename="Export data vehicle"
                                buttonText="Export Excel" />
                            <div style={{ display: 'none' }}>
                                <table border='1' id='tabletoexcel'>
                                    <thead>
                                        <tr>
                                            <th>Perusahaan</th>
                                            <th>Plat Number</th>
                                            <th>Tipe Aset</th>
                                            <th>Vendor</th>
                                            <th>Body Name</th>
                                            <th>Kantor</th>
                                            <th>Maintenance</th>
                                            <th>Merk</th>
                                            <th>Model</th>
                                            <th>Tahun</th>
                                            <th>Status</th>
                                            <th>Disposed</th>
                                            <th>Write Off</th>
                                            <th>Silinder</th>
                                            <th>NOMOR MESIN</th>
                                            <th>Kapasitas Bahan Bakar</th>
                                            <th>Tipe Bahan Bakar</th>
                                            <th>ODO Awal</th>
                                            <th>ODO Saat Ini</th>
                                            <th>Rasio Bahan Bakar (Liter)</th>
                                            <th>Fuel Ratio KM</th>
                                            <th>Minimum Voltase BBM</th>
                                            <th>Maximum Voltase BBM</th>
                                            <th>Dimensi Panjang</th>
                                            <th>Dimensi Lebar</th>
                                            <th>Dimensi Tinggi</th>
                                            <th>Kapasitas Muatan</th>
                                            <th>Manufaktur</th>
                                            <th>Tanggal Manufaktur</th>
                                            <th>Tipe Rangka</th>
                                            <th>Kapasitas Tempat Duduk</th>
                                            <th>Warna</th>
                                            <th>Nomor Sasis</th>
                                            <th>Payload</th>
                                            <th>Berat Poros</th>
                                            <th>Tanggal Pembelian</th>
                                            <th>Dibeli Dari</th>
                                            <th>Harga Pembelian</th>
                                            <th>Kecepatan Maksimal</th>
                                            <th>Kecepatan Minimal</th>
                                            <th>Idle Time</th>
                                            <th>Deskripsi</th>
                                            <th>Temperatur Minimal</th>
                                            <th>Temperatur Maximal</th>
                                            <th>Temperatur Minimal 1</th>
                                            <th>Temperatur Maximal 1</th>
                                            <th>Temperatur Minimal 2</th>
                                            <th>Temperatur Maximal 2</th>
                                        </tr>
                                    </thead>
                                    <tbody >
                                        {dataVehicleExport !== null ?
                                            dataVehicleExport.map((item, indeks) => {
                                                return (
                                                    <tr>
                                                        <td>{item.join.company_name}</td>
                                                        <td>{item.license_plate}</td>
                                                        <td>{item.join.vehicle_type_name}</td>
                                                        <td>{item.join.vendor_name}</td>
                                                        <td>{item.name}</td>
                                                        <td>{item.join.pool_name}</td>
                                                        <td>{item.is_maintenance !== false ? "Yes" : "No"}</td>
                                                        <td>{item.merk}</td>
                                                        <td>{item.model}</td>
                                                        <td>{item.year}</td>
                                                        <td>{item.status ? "Active" : "Not Active"}</td>
                                                        <td>{item.is_disposed ? "Yes" : "No"}</td>
                                                        <td>{item.is_written_off ? "Yes" : "No"}</td>
                                                        <td>{item.tank_capacity}</td>
                                                        <td>{item.engine_no}</td>
                                                        <td>{item.fuel_capacity}</td>
                                                        <td>{item.fuel_type}</td>
                                                        <td>{item.begin_odo}</td>
                                                        <td>{item.current_odo}</td>
                                                        <td>{item.fuel_ratio_litre}</td>
                                                        <td>{item.fuel_ratio_km}</td>
                                                        <td>{item.bbm_volt_min}</td>
                                                        <td>{item.bbm_volt_max}</td>
                                                        <td>{item.length_dimension}</td>
                                                        <td>{item.width_dimension}</td>
                                                        <td>{item.height_dimension}</td>
                                                        <td>{item.load_capacity}</td>
                                                        <td>{item.manufactur}</td>
                                                        <td>{item.manufacturing_date ? moment(item.manufacturing_date).format("D MMM YYYY") : ""}</td>
                                                        <td>{item.body_type}</td>
                                                        <td>{item.seat_capacity}</td>
                                                        <td>{item.color}</td>
                                                        <td>{item.chasis_no}</td>
                                                        <td>{item.payload}</td>
                                                        <td>{item.axle_weight}</td>
                                                        <td>{item.purchase_date ? moment(item.purchase_date).format("D MMM YYYY") : ""}</td>
                                                        <td>{item.purchase_from}</td>
                                                        <td>{item.purchase_price}</td>
                                                        <td>{item.max_speed}</td>
                                                        <td>{item.min_speed}</td>
                                                        <td>{item.idle_time}</td>
                                                        <td>{item.description}</td>
                                                        <td>{item.notif_temperature && item.notif_temperature.minTemp ? item.notif_temperature.minTemp : ""}</td>
                                                        <td>{item.notif_temperature && item.notif_temperature.maxTemp ? item.notif_temperature.maxTemp : ""}</td>
                                                        <td>{item.notif_temperature && item.notif_temperature.minTemp1 ? item.notif_temperature.minTemp1 : ""}</td>
                                                        <td>{item.notif_temperature && item.notif_temperature.maxTemp1 ? item.notif_temperature.maxTemp1 : ""}</td>
                                                        <td>{item.notif_temperature && item.notif_temperature.minTemp2 ? item.notif_temperature.minTemp2 : ""}</td>
                                                        <td>{item.notif_temperature && item.notif_temperature.maxTemp2 ? item.notif_temperature.maxTemp2 : ""}</td>
                                                    </tr>
                                                )
                                            }) : null}
                                    </tbody>
                                </table>
                            </div>
                        </nav>
                    </div>
                </div>
                <hr></hr>
                <SweetAlert show={this.state.sweetSuccess} success title='Success' onConfirm={this.onConfirm}>
                    Data was successfully deleted !
                </SweetAlert>
                <SweetAlert 
                    show={this.state.sweetWarning}
                    warning
                    showCancel
                    confirmBtnText={`${loading ? "Delete..." : "Yes Delete!"}`}
                    confirmBtnBsStyle={`${loading ? 'secondary' : 'danger'}`}
                    disabled={loading}
                    cancelBtnBsStyle="default"
                    title='Are You Sure?'
                    onConfirm={() => {
                        if (!loading) this.handleDelete('delete')
                    }}
                    onCancel={() => { 
                        if (!loading) this.handleDelete('batal')}
                    }
                >
                    {loading ? (
                        <div>
                            <div>Please Wait...</div>
                            <LinearProgress />
                        </div>
                  ) : "You want to delete this data!"}
                </SweetAlert>
                <Paper className={classes.paper} elevation={1}>

                    <Toolbar
                        className={classNames("table-header", {
                            ["highlight-light"]: selected.length > 0,
                        })}
                    >
                        <div className="title">
                            <Button variant="contained" color="primary" className={classes.button} onClick={() => this.handleShowDialog()}>
                                Tambah Aset
                        <AddIcon className={classes.rightIcon} />
                            </Button>

                            <DialogAdd
                                classes={this.props.classes}
                                idData={0}
                                closeDialog={this.handleCloseDialog}
                                showDialog={showDialog => this.showChildDialog = showDialog}
                            />
                            <DialogEdit openEdit={this.state.openEdit} loading={this.state.loading} handleClose={this.handleCloseEdit} data={this.state.dataEdit} />

                        </div>
                        <div className="search-detail" />
                        <div className="actions">
                            <TextField
                                label={`Cari ${this.state.searchDetail}`}
                                value={this.state.search}
                                onChange={(e) => this.setState({ search: e.target.value })}
                                onKeyPress={(ev) => {
                                  if (ev.key === "Enter") {
                                    if (this.state.search)
                                      this.handleMasterVehicle(0, -1);
                                  }
                                }} InputProps={{
                                  endAdornment: (
                                    <InputAdornment position="end">
                                      <PopupState variant="popover" popupId="popup-search">
                                        {(popupState) => (
                                          <React.Fragment>
                                            <IconButton
                                              {...bindTrigger(popupState)}
                                              aria-label="more"
                                              aria-controls="long-menu"
                                              aria-haspopup="true"
                                            >
                                              <i className="zmdi zmdi-caret-down"></i>
                                            </IconButton>
                                            <Menu {...bindMenu(popupState)}>
                                              <MenuItem
                                                onClick={(e) => {
                                                  popupState.close();
                                                  this.setState({
                                                    searchDetail: "Nomor Plat",
                                                    searchDetailField: "license_plate",
                                                    searchTableName: "",
                                                  });
                                                }}
                                              >
                                                Nomor Plat
                                              </MenuItem>
                                              <MenuItem
                                                onClick={(e) => {
                                                  popupState.close();
                                                  this.setState({
                                                    searchDetail: "Perusahaan",
                                                    searchDetailField: "name",
                                                    searchTableName: "m_company",
                                                  });
                                                }}
                                              >
                                                Perusahaan
                                              </MenuItem>
                                              <MenuItem
                                                onClick={(e) => {
                                                  popupState.close();
                                                  this.setState({
                                                    searchDetail: "Tipe Aset",
                                                    searchDetailField: "name",
                                                    searchTableName: "m_vehicle_type",
                                                  });
                                                }}
                                              >
                                                Tipe Aset
                                              </MenuItem>
                                              <MenuItem
                                                onClick={(e) => {
                                                  popupState.close();
                                                  this.setState({
                                                    searchDetail: "Vendor",
                                                    searchDetailField: "name",
                                                    searchTableName: "m_vendor",
                                                  });
                                                }}
                                              >
                                                Vendor
                                              </MenuItem>
                                              <MenuItem
                                                onClick={(e) => {
                                                  popupState.close();
                                                  this.setState({
                                                    searchDetail: "Body Name",
                                                    searchDetailField: "name",
                                                    searchTableName: "",
                                                  });
                                                }}
                                              >
                                                Body Name
                                              </MenuItem>
                                              <MenuItem
                                                onClick={(e) => {
                                                  popupState.close();
                                                  this.setState({
                                                    searchDetail: "Kantor",
                                                    searchDetailField: "name",
                                                    searchTableName: "m_pool",
                                                  });
                                                }}
                                              >
                                                Kantor
                                              </MenuItem>
                                            </Menu>
                                          </React.Fragment>
                                        )}
                                      </PopupState>
                                    </InputAdornment>
                                  ),
                                }}
                              />
                        </div>
                    </Toolbar>
                    <Dialog
                        open={this.state.openQr}
                        onClose={() => this.setState({ openQr: false })}
                        TransitionComponent={Transition}
                        keepMounted
                        aria-labelledby="alert-dialog-slide-title"
                        aria-describedby="alert-dialog-slide-description"
                    >
                        <DialogTitle id="max-width-dialog-title">
                            {this.state.nameQr}
                            <br /><br />
                            <Divider />
                        </DialogTitle>

                        <DialogContent>
                            {/* <DialogContentText>
                        You can set multiple filter.
                        </DialogContentText> */}
                            <Grid container spacing={24}>
                                <Grid item xs={4}>
                                    <img 
                                        src={this.state.urlQr} 
                                        width={300}
                                        height={300}
                                        alt="qr code"
                                    />
                                </Grid>
                            </Grid>
                        </DialogContent>
                        <DialogActions>
                            <Button variant="raised" className="bg-white text-black" onClick={() => this.setState({ openQr: false })} color="primary">
                                Close
                        </Button>

                        </DialogActions>
                    </Dialog>
                    <Dialog
                        open={this.state.openPhoto}
                        onClose={() => this.setState({ openPhoto: false })}
                        TransitionComponent={Transition}
                        keepMounted
                        aria-labelledby="alert-dialog-slide-title"
                        aria-describedby="alert-dialog-slide-description"
                    >
                        <DialogTitle id="max-width-dialog-title">
                            {this.state.nameImage}
                            <br /><br />
                            <Divider />
                        </DialogTitle>

                        <DialogContent>
                            {/* <DialogContentText>
                        You can set multiple filter.
                        </DialogContentText> */}
                            <Grid container spacing={24}>
                                <Grid item xs={4}>
                                    <img src={this.state.urlPhoto} width="250" height="250"></img>
                                </Grid>
                            </Grid>
                        </DialogContent>
                        <DialogActions>
                            <Button variant="raised" className="bg-white text-black" onClick={() => this.setState({ openPhoto: false })} color="primary">
                                Close
                        </Button>

                        </DialogActions>
                    </Dialog>
                    <div className="flex-auto">
                        <div className="table-responsive-material">
                            <Table>
                                <TableHead>
                                    <TableRow>
                                        <TableCell padding="none" style={{ fontWeight: 'bolder', fontSize: 14 }}>
                                            Aksi
                                </TableCell>
                                        {columnData.map(column => {
                                            return (
                                                <TableCell key={column.id} padding="none" style={{ fontSize: '14px' }}>
                                                    <Tooltip
                                                        title="Sort"
                                                        placement="bottom-start"
                                                        enterDelay={100}
                                                    >
                                                        <TableSortLabel
                                                            active={orderBy === column.id}
                                                            direction={order}
                                                            onClick={this.createSortHandler(column.id)}
                                                        >
                                                            {column.label}
                                                        </TableSortLabel>
                                                    </Tooltip>
                                                </TableCell>
                                            );
                                        }, this)}
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {dataVehicle.map(n => {
                                        const isSelected = this.isSelected(n.id);
                                        return (
                                            <TableRow
                                                hover
                                                key={n.id}
                                            >
                                                <TableCell padding="none">

                                                    <Tooltip title="Edit" placement="top">
                                                        <IconButton color="primary" className="text-green" onClick={() => this.handleClickOpenEdit(n)}>
                                                            <i className="zmdi zmdi-edit"></i>
                                                        </IconButton>
                                                    </Tooltip>
                                                    <Tooltip title="Delete" placement="top">
                                                        <IconButton color="primary" className="text-red" onClick={() => this.handleDeleteData(n)}>
                                                            <i className="zmdi zmdi-delete"></i>
                                                        </IconButton>
                                                    </Tooltip>
                                                    <Tooltip title="View QR Code" placement="top">
                                                        <IconButton color="primary" className="text-primary" onClick={() => this.handleViewQr(n)}>
                                                            <i className="zmdi zmdi-collection-item"></i>
                                                        </IconButton>
                                                    </Tooltip>
                                                    <Tooltip title="View Photo" placement="top">
                                                        <IconButton color="primary" className="text-amber" onClick={() => this.handleViewPhoto(n)}>
                                                            <i className="zmdi zmdi-collection-image"></i>
                                                        </IconButton>
                                                    </Tooltip>
                                                </TableCell>
                                                <TableCell padding="none">{n.join.company_name}</TableCell>
                                                <TableCell padding="none">{n.license_plate}</TableCell>
                                                <TableCell padding="none">{n.join.vehicle_type_name}</TableCell>
                                                <TableCell padding="none">{n.join.vendor_name}</TableCell>
                                                <TableCell padding="none">{n.name}</TableCell>
                                                <TableCell padding="none">{n.join.pool_name}</TableCell>
                                                <TableCell padding="none">{n.is_maintenance ? "Maintenance" : ""}</TableCell>

                                            </TableRow>
                                        );
                                    })}
                                </TableBody>
                                <TableFooter>
                                    <TableRow>
                                        <TablePagination
                                            count={totalRecordVehicle}
                                            rowsPerPage={this.state.rowsPerPage}
                                            page={page}
                                            onChangePage={this.handleChangePage}
                                            onChangeRowsPerPage={this.handleChangeRowsPerPage}
                                        />
                                    </TableRow>
                                </TableFooter>
                            </Table>
                        </div>
                    </div>
                </Paper>
            </div>
        );
    }
}

export default withStyles(styles)(MasterVehicle);


// WEBPACK FOOTER //
// ./app/routes/MasterVehicle/index.js